import React from 'react';
import PriceBanner from './PriceBanner';
import Badge from '../../card/Badge';

export const BreadcrumbSingle = ({event, host, location, type = 'eventDetails'}) => {
    switch (type) {
        case 'eventDetails': {
            const {title: eventTitle, prices, is_highlight, is_online_event, location} = event;
            return (
                <div className="col-lg-8 col-md-7">
                    <ul className="list-unstyled listing-info--badges">
                        {is_highlight && <Badge type="highlight" description="Highlight" />}
                        {is_online_event && <Badge type="online" description="Online" />}
                    </ul>

                    <ul className="list-unstyled listing-info--meta">
                        <PriceBanner prices={prices} />
                        <li className="header-address">
                            <div className="atbd_listing_category">
                                <span className="la la-map-marker" />{location.address + ', ' + location.city}
                            </div>
                        </li>
                    </ul>
                    <h1>{eventTitle}</h1>
                </div>
            );
        }
        case 'hostDetails': {
            const {telephone, email, title: hostTitle} = host;
            return (
                <div className="col-lg-8 col-md-7">
                    <ul className="list-unstyled listing-info--meta">
                        {telephone && (
                            <li>
                                <span className="atbd_meta atbd_listing_average_pricing">
                                    {telephone}
                                </span>
                            </li>
                        )}
                        {email && (
                            <li>
                                <div className="atbd_listing_category">
                                    <span className="la la-glass" />
                                    <a href={'mailto:' + email} >{email}</a>
                                </div>
                            </li>
                        )}
                    </ul>
                    <h1>{hostTitle}</h1>
                </div>
            );
        }
        case 'locationDetails': {
            const {address, title} = location;
            return (
                <div className="col-lg-8 col-md-7">
                    <ul className="list-unstyled listing-info--meta">
                        <li className="header-address">
                            <div className="atbd_listing_category">
                                <span className="la la-map-marker" />{address}
                            </div>
                        </li>
                    </ul>
                    <h1>{title}</h1>
                </div>
            );
        }
        default: return;
    }
};

export default BreadcrumbSingle;
